

module.exports = __webpack_require__.stylable.create(
    "Divider1878984517",
    {"classes":{"root":"Divider1878984517__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "Divider1878984517",
    null
);
